import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { studentFeedbackModel } from "./student-feedback-model";

export class studentFeedbackGridModel extends studentFeedbackModel { }

export class studentFeedbackListingModel extends GridModel<studentFeedbackGridModel> { }
export class studentFeedbackGridPostParams extends GridPostParams {
    
}